import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AbcIcon from "@mui/icons-material/Abc";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

export const BlocksVariablePage = (props) => {
  const [open, setOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [menu, setMenu] = useState(false);
  return (
    <div className="get-started-page">
      <header className="topbar">
        <IconButton
          className="menu-button"
          onClick={() => {
            setMenu(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="topbar-logo">
          <a href="https://www.fabloq.com">
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="block"></div>
            </div>
          </a>
        </div>
        <span className="topbar-docs">Docs</span>
      </header>

      <main className="content">
        <Drawer
          open={menu}
          onClose={() => {
            setMenu(false);
          }}
          className="drawer"
        >
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </Drawer>
        <div className="sidebar" style={{ height: window.innerHeight - 55 }}>
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </div>
        <div className="article">
          <div className="article-left" />
          <div className="article-content">
            <h2 className="topic-title" id="variable-block">
              <span className="hashtag">#</span> Variable Block
            </h2>
            <p className="topic-para">
              Variable blocks store a value which can be used later on in
              building the endpoint. You can store Text, Number, a List and a
              Dictionary.
            </p>
            <h2 className="topic-title" id="how-to-create-a-variable-block">
              <span className="hashtag">#</span> How to create a variable block
            </h2>
            <ol>
              <li className="topic-para">
                Select plus icon at the center of workspace and in the dialog
                box select “Variable” under “Control Blocks”.
              </li>
              <li className="topic-para">
                Next, enter name and value of the variable. Later if you want to
                use this value, you will simply use this variable name.
              </li>
              <li className="topic-para">
                Select “Add” to add variable blocks.
              </li>
            </ol>
            <h2 className="topic-title" id="how-to-use-variables">
              <span className="hashtag">#</span> How to use variable
            </h2>
            <p className="topic-para">
              To use the value in the variable in different blocks, put variable
              name in double curly braces. For example to use value stored in
              variable named “name” you have to use as follows:
            </p>
            <div className="topic-code">
              <p className="topic-para">{"{{name}}"}</p>
            </div>
            <p className="topic-para">
              To use the value of key of dictionary simply use dot operator:
            </p>
            <div className="topic-code">
              <p className="topic-para">{"{{dictionary.key}}"}</p>
            </div>
            <p className="topic-para">
              To access element of a list simply use list index in a pair of
              square brackets:
            </p>
            <div className="topic-code">
              <p className="topic-para">{"{{list[0]}}"}</p>
            </div>
            <h2 className="topic-title" id="reserved-variables">
              <span className="hashtag">#</span> Reserved variables
            </h2>
            <p className="topic-para">
              There are 2 reserved variables with “data” variable and “user”
              variable.
            </p>
            <ol>
              <li className="topic-para">
                data variable stores the JSON data sent in the API request or
                via get parameters. To access particular key in JSON data use
                following:
              </li>
              <div className="topic-code">
                <p className="topic-para">{"data.key"}</p>
              </div>
              <li className="topic-para">
                User variable stores user data who is sending request. This is
                only possible if the user has been authenticated prior and
                request has the JWT token which was generated during sign in.
                <br></br>
                <br></br>
                User variable has following keys: name, username, email and id.
                You can access those as following:
                <div className="topic-code">
                  <p className="topic-para">{"user.key"}</p>
                </div>
              </li>
            </ol>
            <div className="topic-footline"></div>
            <div className="topic-buttons">
              <Button component={RouterLink} to="/blocks/overview">
                <ChevronLeftIcon /> Overview
              </Button>
              <Button component={RouterLink} to="/blocks/response">
                Response <ChevronRightIcon />
              </Button>
            </div>
          </div>
          <div className="article-right" />
        </div>
        <div className="index">
          <a className="index-title">Contents</a>
          <a className="index-topic" href="#variable-block">
            Variable Block
          </a>
          <a className="index-topic" href="#how-to-create-a-variable-block">
            How to create a variable block
          </a>
          <a className="index-topic" href="#how-to-use-variables">
            How to use variable
          </a>
          <a className="index-topic" href="#reserved-variables">
            Reserved variables
          </a>
          {/* <div className="index-sublist">
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
            </div> */}
        </div>
      </main>
    </div>
  );
};
